/* Vitals homepage 2026 — "The Vitals Loop" hero dial.
   One instance per [data-loop] root, so the section can be duplicated.

   State is (active stage, dial rotation, hovered stage, wide?). Everything
   else is derived in render(). The dial rotates by the *shortest* signed
   delta so stepping 5 -> 0 turns forwards 60deg rather than back 300deg. */
(function () {
  if (window.__h26Loop) return;
  window.__h26Loop = true;

  var EASE = 'cubic-bezier(.2,.7,.2,1)';
  var ORANGE = '#FF6E3B', GREEN = '#12664E';
  var CIRC = 2 * Math.PI * 116;          // progress arc circumference
  var HEAD = 55.5;                       // petal head centre, in the dial's own units
  var WIDE = 1180;                       // px of section width for the two-column layout
  /* card slot per stage: [side (+1 right / -1 left), row (0 top / 1 mid / 2 bottom)] */
  var SLOT = [[1, 0], [1, 1], [1, 2], [-1, 2], [-1, 1], [-1, 0]];
  var ROW_Y = [-140, 0, 140];            // glow offset from dial centre, per row

  function shortest(from, to) { return from + (((to - from) % 360 + 540) % 360 - 180); }

  function init(root) {
    if (root.__loop) return;
    root.__loop = true;

    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var petals = qa('[data-loop-petal]');
    var nums   = qa('[data-loop-num]');
    var cards  = qa('[data-loop-card]');
    var nodes  = qa('[data-loop-node]');
    var arc    = q('[data-loop-arc]');
    var orbit  = q('[data-loop-orbit]');
    var glow   = q('[data-loop-glow]');
    var track  = q('[data-loop-track]');
    var hint   = q('[data-loop-hint]');
    var live   = q('[data-loop-live]');

    var n = petals.length;
    if (!n) return;

    var autoplay = root.getAttribute('data-loop-autoplay') !== 'false';
    var dwell = parseInt(root.getAttribute('data-loop-dwell') || '4000', 10);
    var step = 360 / n;

    var i = 0, rot = 0, hov = null, wide = false, leaveT = null, timer = null;

    function go(next) {
      if (next === i) return;
      rot = shortest(rot, next * step);
      i = next;
      render();
    }
    function enter(k) {
      clearTimeout(leaveT);
      go(k);
      if (hov !== k) { hov = k; render(); }
    }
    function leave() {
      clearTimeout(leaveT);
      leaveT = setTimeout(function () { hov = null; render(); }, 260);
    }

    function render() {
      var k;

      /* --- dial --- */
      arc.style.strokeDashoffset = CIRC * (1 - i / n);
      orbit.style.transform = 'rotate(' + rot + 'deg)';

      for (k = 0; k < n; k++) {
        var act = k === i, dim = hov !== null && !act;
        var a = k * step * Math.PI / 180;
        var r = (HEAD + (act ? 3 : 0)) * 2;   // *2 for the SVG's scale(2)

        petals[k].style.fill = act ? ORANGE : GREEN;
        petals[k].style.opacity = dim ? '.4' : '1';
        /* Scale only — the old translateY pushed the top petal outwards into
           the ring, which is what capped how far the hexagon could come in. */
        petals[k].style.transform = act ? 'scale(1.03)' : 'none';

        nums[k].style.left = (250 + Math.sin(a) * r) + 'px';
        nums[k].style.top = (250 - Math.cos(a) * r) + 'px';
        nums[k].style.opacity = dim ? '.7' : '.95';
      }

      /* --- glow: follows the active petal, or parks on the open card --- */
      var gx, gy;
      if (hov === null || !wide) {
        var ang = i * step * Math.PI / 180;
        gx = Math.sin(ang) * 170; gy = -Math.cos(ang) * 170;
      } else {
        gx = SLOT[hov % SLOT.length][0] * 430;
        gy = ROW_Y[SLOT[hov % SLOT.length][1]];
      }
      glow.style.transform = 'translate(' + gx + 'px, ' + gy + 'px)';

      /* --- cards ---
         Wide: a card is a hover reveal, so nothing is open until you point at
         the dial. Narrow: there is nothing to point at and the cards sit in
         flow under the dial, so the active card rides the loop instead —
         otherwise autoplay would run against a permanently empty card slot. */
      var open = hov !== null ? hov : (wide ? -1 : i);
      for (k = 0; k < cards.length; k++) {
        cards[k].classList.toggle('is-on', k === open);
        cards[k].setAttribute('aria-hidden', k === open ? 'false' : 'true');
      }

      /* --- footer rail --- */
      track.style.width = 'calc((100% - 20px) * ' + (i / (n - 1)) + ')';
      for (k = 0; k < nodes.length; k++) {
        nodes[k].classList.toggle('is-on', k === i);
        nodes[k].classList.toggle('is-done', k < i);
        if (k === i) nodes[k].setAttribute('aria-current', 'true');
        else nodes[k].removeAttribute('aria-current');
      }

      root.classList.toggle('is-open', hov !== null);
      if (hint) hint.style.opacity = hov === null ? '1' : '0';
      if (live && nodes[i]) live.textContent = nodes[i].getAttribute('data-loop-label') || '';
    }

    /* --- interaction ---------------------------------------------------- */
    function bind(el, k) {
      el.addEventListener('mouseenter', function () { enter(k); });
      el.addEventListener('mouseleave', leave);
      el.addEventListener('click', function () { enter(k); });
      el.addEventListener('focus', function () { enter(k); });
      el.addEventListener('blur', leave);
    }
    petals.forEach(bind);
    cards.forEach(function (el, k) {
      el.addEventListener('mouseenter', function () { enter(k); });
      el.addEventListener('mouseleave', leave);
    });
    nodes.forEach(function (el, k) {
      bind(el, k);
      el.addEventListener('keydown', function (ev) {
        var d = ev.key === 'ArrowRight' ? 1 : ev.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        ev.preventDefault();
        var next = (i + d + n) % n;
        enter(next);
        nodes[next].focus();
      });
    });

    /* --- autoplay: pauses while a card is open or the tab is hidden ----- */
    function tick() {
      if (!autoplay || hov !== null || document.hidden) return;
      go((i + 1) % n);
    }
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (autoplay && !reduced) timer = setInterval(tick, dwell);

    /* --- layout ---------------------------------------------------------- */
    function measure(w) {
      var next = w >= WIDE;
      if (next === wide) return;
      wide = next;
      root.classList.toggle('is-wide', wide);
      render();
    }
    if ('ResizeObserver' in window) {
      new ResizeObserver(function (e) { measure(e[0].contentRect.width); }).observe(root);
    } else {
      measure(root.offsetWidth);
      window.addEventListener('resize', function () { measure(root.offsetWidth); });
    }
    measure(root.offsetWidth);
    render();
  }

  function scan() { document.querySelectorAll('[data-loop]').forEach(init); }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
})();
